(function () {
  let currentVariantId = null;
  let controller = null;
  let sectionId = null;
  let listenersBound = false;

  function getSpecificationsContainer(root) {
    const accordions = root.querySelectorAll('.about__accordion-item');

    for (const accordion of accordions) {
      if (accordion.querySelector('.meta-row')) {
        return accordion.querySelector(
          '.about__accordion-description.richtext__content'
        );
      }
    }

    return null;
  }

  async function refreshSpecifications(sectionId, variantId) {
    if (!sectionId || !variantId || variantId === currentVariantId) return;

    if (controller) controller.abort();
    controller = new AbortController();

    try {
      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString(), {
        signal: controller.signal,
        cache: 'no-store',
      });

      if (!response.ok) throw new Error('Section request failed');

      const html = await response.text();
      const newDocument = new DOMParser().parseFromString(html, 'text/html');
      const currentSpecifications = getSpecificationsContainer(document);
      const newSpecifications = getSpecificationsContainer(newDocument);

      if (currentSpecifications && newSpecifications) {
        currentSpecifications.innerHTML = newSpecifications.innerHTML;
        currentVariantId = variantId;
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Could not refresh specifications:', error);
      }
    }
  }

  function onVariantPickerChange(event) {
    if (!sectionId) return;

    const picker = event.target.closest('variant-radios, variant-selects');
    if (!picker?.currentVariant?.id) return;

    refreshSpecifications(sectionId, String(picker.currentVariant.id));
  }

  function onPopState() {
    if (!sectionId) return;

    const variantId = new URL(window.location.href).searchParams.get('variant');
    refreshSpecifications(sectionId, variantId);
  }

  function boot() {
    const productInfo = document.querySelector('[id^="ProductInfo-"][data-section]');
    if (!productInfo) return;

    sectionId = productInfo.dataset.section;
    currentVariantId =
      new URL(window.location.href).searchParams.get('variant') ||
      productInfo.querySelector('input[name="id"]')?.value ||
      null;

    if (!listenersBound) {
      document.addEventListener('change', onVariantPickerChange);
      window.addEventListener('popstate', onPopState);
      listenersBound = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
